module.exports = __webpack_public_path__ + "static/media/close.f73263ad.png";